import whiteMark from "../assets/mfg-logo-dark.png";
import darkMark from "../assets/mfg-logo-light.png";
import { useTheme } from "../contexts/ThemeContext";

export const brandLogoDark = whiteMark;
export const brandLogoLight = darkMark;

/** Theme-aware MFG Invest mark. Dark mark on light UI, white mark on dark UI. */
export function useBrandLogo() {
  const { isDarkMode } = useTheme();
  return isDarkMode ? whiteMark : darkMark;
}

/** White mark for splash and other surfaces that stay dark. */
export default whiteMark;
